import { makeStyles } from "@material-ui/core";
import ThemeSwitcher from "../../../Optime/ThemeSwitcher/ThemeSwitcher";

const ThemeColors = ThemeSwitcher(true);

export const LoaderStyle = makeStyles( theme => ({
  Wrapper: {
    width: '100%',
    textAlign: "center",
    fontSize: 28,
    fontWeight: "bold",
    fontFamily: "Caviar",
    color: `${ThemeColors[8]}`,
    opacity: '.5',
  },
  optimeLogo: {
    position: 'fixed',
    top: 30,
    width: 300,
    height: 'auto',
  },
  BackgroundImageWrapper: {
    position: 'fixed',
    bottom: '0',
    // width: '100%',
    // height: '500px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    height: '100vh',
    width: '100vw',
    zIndex: '-1',
  },
  MessageWrapper: {
    animation: `$bounce 2s linear infinite`,
  },
  "@keyframes bounce": {
    '0%': {
      letterSpacing: 0,
    },
    '50%': {
      letterSpacing: 5,
    },
    '100%': {
      letterSpacing: 0,
    },
  }
}));